import React from 'react';
import './../styles/chat.css';
import { Outlet } from 'react-router-dom';
import NavbarTop from './chat/Navbartop';

const Chat = () => {
    return (
        <div className="app-chat app-container">
            <NavbarTop />
            <div className="main-content">
                <div className="page-container">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Chat;